import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ButtonModule } from '@components/button';
import { UserAddressBottomsheetComponent } from './user-address-bottomsheet.component';

@NgModule({
  imports: [
    CommonModule,
    ButtonModule,
  ],
  declarations: [UserAddressBottomsheetComponent],
  exports: [UserAddressBottomsheetComponent],
})
export class UserAddressBottomsheetModule {}
